import { render, staticRenderFns } from "./EnviarSenhaNova.vue?vue&type=template&id=7968e175&"
import script from "./EnviarSenhaNova.vue?vue&type=script&lang=js&"
export * from "./EnviarSenhaNova.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports